import React from 'react';
import { Thumbnail, Icon, Media } from '@fieldnation/platform-components';
import isNil from 'lodash/isNil';
import classes from './ProfileContent.scss';
import { ProfileContentProps } from './types.d';

const ProfileContent = ({
  estimateHour,
  thumbnail,
  name,
  workOrderId,
  workOrderTitle,
  loggedHours,
  lateTime,
  problemsReported,
}: ProfileContentProps): React.ReactElement => {
  const displayName = name;

  return (
    <div className={classes.ProfileContent}>
      <div className={classes.ProfileHeader}>
        <Media
          verticalAlign="middle"
          element={(
            <div className={classes.ProfileThumbnail}>
              <Thumbnail
                widthAuto={1}
                title={displayName}
                src={thumbnail || '/images/missing-profile.png'}
              />
            </div>
          )}
          body={(
            <div>
              <div className={classes.ProfileName}>
                {displayName}
              </div>
            </div>
          )}
        />
      </div>

      <hr className={classes.Divider} />

      <div className={classes.WorkOrderSection}>
        <div className={classes.WorkOrderId}>
          ID
          {' '}
          {workOrderId}
        </div>

        <p className={classes.WorkOrderTitle}>
          <a
            href={`/workorders/${workOrderId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.WorkOrderTitleLink}
          >
            {workOrderTitle}
          </a>
        </p>

        <div className={classes.StatusRow}>
          {!!estimateHour && (
            <div className={classes.StatusItem}>
              <div className={classes.StatusIcon}>
                <Icon name="avgPace" size={18} />
              </div>
              <span className={classes.StatusText}>
                Est.
                {' '}
                {estimateHour}
                {' '}
                {estimateHour === 1 ? 'hr' : 'hrs'}
              </span>
            </div>
          )}

          {!!loggedHours && loggedHours > 0 && (
            <div className={classes.StatusItem}>
              <div className={classes.StatusIcon}>
                <Icon name="punchClockFilled" size={18} />
              </div>
              <span className={classes.StatusText}>
                {+loggedHours.toFixed(1)}
                {' '}
                {loggedHours === 1 ? 'hr' : 'hrs'}
                {' '}
                logged
              </span>
            </div>
          )}

          {!!lateTime && (
            <div className={classes.StatusItem}>
              <div className={classes.StatusIcon}>
                <Icon name="timerFilled" size={18} />
              </div>
              <span className={classes.StatusText}>
                {lateTime}
              </span>
            </div>
          )}

          {!isNil(problemsReported) && (
            <div className={classes.StatusItem}>
              <div className={classes.StatusIcon}>
                <Icon name="warningSolid" size={18} />
              </div>
              <span className={classes.StatusText}>
                {problemsReported}
                {' '}
                {problemsReported === 1 ? 'problem' : 'problems'}
                {' '}
                reported
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileContent;
